export default [
  {
    path: '/cash/:key?',
    name: 'cashIndex',
    component: () => import('@/views/cash/CashIndex.vue'),
    meta: {},
  },
];
